module.exports = __webpack_public_path__ + "img/CLK.2bef8c49.png";